import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { CountryListComponent } from "./country-list/country-list.component";

const routes: Routes = [
  {
    path: "countries",
    component: CountryListComponent,
    canActivate: [AuthGuard],
  },
];

export const CountriesRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/countries/countries.routes.ts